import React from "react";
import Footer from "../../../../containers/Footer";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

import JackpotBanner from "../../../../assets/images/banner/jackpotbanner.webp"
import star from "../../../../assets/images/icons/star.png";
import logo from "../../../../assets/images/logo.png";

const Jackpots = () => {
    return (
        <>
            <HeaderAfterLogin />
            <div className="container-fluid">
                <main className="main">
                    <div className="OffersSection">
                        <div className="OfferBanner">
                            <img src={JackpotBanner} alt="Offerbanner" />
                        </div>

                        <div className="Offercontent JackpotContent">
                            <p><img src={star} alt="start" />Our Lucky Winners<img src={star} alt="start" /></p>
                            <p className="bigwinner">FN777_VarunS Jackpot Winners</p>
                            <ul className="">
                                <li><img src={logo} alt="logo" />Ramesh64 - <span>Weekly Jackpot Winners</span></li>
                                <li><img src={logo} alt="logo" /> Srnivas175 - <span>1st Loyality Winners</span></li>
                                <li><img src={logo} alt="logo" /> Amaresh - <span>2nd Loyality Winners</span></li>
                                <li><img src={logo} alt="logo" /> Rajani179 - <span>3rd Loyality Winners</span></li>
                                <li><img src={logo} alt="logo" /> FN777_Rudhu90 - <span>Lucky Loser of the Week</span></li>
                                <li><img src={logo} alt="logo" /> FN777_Akash - <span>Lucky Loser of the Week</span></li>
                                <li><img src={logo} alt="logo" /> FN777_Adharsh21  - <span>20% Deposit Winner</span></li>
                                <li><img src={logo} alt="logo" /> FN777_Katral123 - <span>20% Deposit Winner</span></li>
                                <li> <img src={logo} alt="logo" /> Asif - <span>20% Extra Coin Bonus on Every Deposit</span></li>
                            </ul>
                            <p> Play now on <span>Funn777.com</span> & Win Big & Have Fun!</p>
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
  );
}

export default Jackpots;